import { authenticatedMiddleware } from '@/middleware/AuthenticatedMiddleware.js'
import Sessions from '@/views/authenticated/Sessions.vue'

export const sessionRoutes = [
  {
    path: '/sessions',
    name: 'sessions',
    component: Sessions,
    beforeEnter: [authenticatedMiddleware],
  },
]
